/**
 * Created by Bob.Gear on 3/05/14.
 */
//------------------------------------------------------------------------
//  industrySectorFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
    .controller('projectStagesFilterController', ['$scope', 'lookupTables',
      function ($scope, lookupTables) {
        $scope.componentName = "projectStagesFilter";

        $scope.projectStages = lookupTables.projectStages();

        $scope.resetFilter = function () {
          $scope.clearProjectStageSelections();
        };

        $scope.clearProjectStageSelections = function () {
          $scope.criteria.selectedProjectStages = null;
          delete $scope.criteria["selectedProjectStages"];
        };

        $scope.removeProjectStagesFilter = function () {
          $scope.resetFilter();
          $scope.$parent.removeFilter("#projectStagesFilter");
        };

        $scope.$watch("criteria.selectedProjectStages.length", function () {
          if (!$scope.criteria.selectedProjectStages) return;

          $scope.selectedCount = $scope.criteria.selectedProjectStages.length;
          $scope.plural = ($scope.selectedCount === 1) ? "" : "s";
        });

      }])
    .directive('projectStagesFilter', ['$compile',
      function ($compile) {
        return {
          replace:     true,  // replace the placeholder element with the template
          restrict:    'A',   // usage: <div projectNameFilter />
          templateUrl: "../app-ds3/search/queryBuilder/filters/projectStagesFilter.tmpl.html",

          link: function ($scope, iElement, iAttrs) {
          },

          controller: 'projectStagesFilterController'
        };
      }]);
//------------------------------------------------------------------------
